var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardio4AllLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cardio4all-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 169.288,
    height: 34.244,
    viewBox: "0 0 169.288 34.244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15884",
    "data-name": "Rectangle 15884",
    width: 169.288,
    height: 34.244,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48543",
    "data-name": "Group 48543",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65175",
    "data-name": "Path 65175",
    d: "M25.175.632.618,25.189A2.11,2.11,0,0,0,3.6,28.173L28.159,3.616A2.11,2.11,0,0,0,25.175.632",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65176",
    "data-name": "Path 65176",
    d: "M33.758,8.206,8.2,33.768a2.11,2.11,0,0,0,2.984,2.984L36.742,11.19c1.957-1.9-1.071-4.954-2.984-2.984",
    transform: "translate(-3.825 -3.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65177",
    "data-name": "Path 65177",
    d: "M42.41,24.013,23.972,42.451a2.11,2.11,0,0,0,2.984,2.984L45.394,27a2.11,2.11,0,1,0-2.984-2.984",
    transform: "translate(-11.788 -11.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65178",
    "data-name": "Path 65178",
    d: "M51.085,42.392l-8.723,8.723A2.11,2.11,0,0,0,45.346,54.1l8.723-8.723a2.11,2.11,0,0,0-2.984-2.984",
    transform: "translate(-21.071 -21.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65179",
    "data-name": "Path 65179",
    d: "M59.4,62.753h0a2.11,2.11,0,0,0,2.984,0l.343-.343a2.11,2.11,0,0,0-2.984-2.984l-.343.343a2.11,2.11,0,0,0,0,2.984",
    transform: "translate(-29.669 -29.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65180",
    "data-name": "Path 65180",
    d: "M31.03,1.012h0a2.11,2.11,0,0,0-2.984,0L23.3,5.755a2.11,2.11,0,0,0,2.984,2.984L31.03,4a2.11,2.11,0,0,0,0-2.984",
    transform: "translate(-11.45 -0.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65181",
    "data-name": "Path 65181",
    d: "M8.662,23.225h0a2.11,2.11,0,0,0-2.984,0L.935,27.968a2.11,2.11,0,0,0,2.984,2.984l4.743-4.743a2.11,2.11,0,0,0,0-2.984",
    transform: "translate(-0.16 -11.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65182",
    "data-name": "Path 65182",
    d: "M93.108,32.27a6.591,6.591,0,0,1-2.024,1.508,6.719,6.719,0,0,1-3.056.649,7.722,7.722,0,0,1-2.89-.544,6.658,6.658,0,0,1-2.313-1.591,7.153,7.153,0,0,1-1.548-2.428,8.453,8.453,0,0,1-.558-3.12,8.2,8.2,0,0,1,.578-3.161,6.914,6.914,0,0,1,1.569-2.429A6.768,6.768,0,0,1,85.2,19.625a7.722,7.722,0,0,1,2.89-.545,7.889,7.889,0,0,1,2.829.545,5.676,5.676,0,0,1,2.065,1.36.385.385,0,0,1,0,.419l-2.147,2.282a.258.258,0,0,1-.186.084.285.285,0,0,1-.207-.1,2.716,2.716,0,0,0-.867-.649,3.563,3.563,0,0,0-1.383-.293,3.2,3.2,0,0,0-1.4.314,3.079,3.079,0,0,0-1.095.817,3.862,3.862,0,0,0-.723,1.277,4.474,4.474,0,0,0-.268,1.612,4.59,4.59,0,0,0,.268,1.633,3.668,3.668,0,0,0,.7,1.256,3.022,3.022,0,0,0,1.094.816,3.271,3.271,0,0,0,1.383.293,3.092,3.092,0,0,0,1.508-.356,2.994,2.994,0,0,0,.908-.775.224.224,0,0,1,.186-.084h.021a.224.224,0,0,1,.186.084l2.127,2.261a.319.319,0,0,1,.021.4",
    transform: "translate(-40.743 -9.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65183",
    "data-name": "Path 65183",
    d: "M122.272,34.174a.24.24,0,0,1-.248.252H118.37a.218.218,0,0,1-.207-.167l-1.012-2.743h-4.934l-.93,2.743a.242.242,0,0,1-.227.167h-3.572a.253.253,0,0,1-.207-.1.352.352,0,0,1-.021-.251l5.7-14.822a.242.242,0,0,1,.227-.167h3.2a.238.238,0,0,1,.207.167l5.636,14.8a.3.3,0,0,1,.041.125m-7.557-10.112-1.383,4.062h2.746Z",
    transform: "translate(-54.134 -9.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65184",
    "data-name": "Path 65184",
    d: "M151.146,34.3a.28.28,0,0,1-.227.126h-3.861a.254.254,0,0,1-.227-.147l-2.911-5.736H143.2v5.632a.253.253,0,0,1-.248.251h-3.221a.272.272,0,0,1-.268-.251V19.332a.258.258,0,0,1,.268-.252h5.224a9,9,0,0,1,1.982.23,5.417,5.417,0,0,1,1.775.775,4.186,4.186,0,0,1,1.259,1.487,4.9,4.9,0,0,1,.475,2.24,4.444,4.444,0,0,1-.805,2.7,4.215,4.215,0,0,1-1.92,1.445l3.428,6.092a.27.27,0,0,1,0,.251m-4.625-11.326a1.048,1.048,0,0,0-.434-.418,1.539,1.539,0,0,0-.64-.209,4.369,4.369,0,0,0-.723-.063h-1.549v2.994h1.342a5.189,5.189,0,0,0,.805-.063,2.5,2.5,0,0,0,.7-.23,1.556,1.556,0,0,0,.5-.481,1.46,1.46,0,0,0,.186-.8,1.28,1.28,0,0,0-.186-.733",
    transform: "translate(-70.392 -9.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65185",
    "data-name": "Path 65185",
    d: "M179.044,26.722a8.1,8.1,0,0,1-.681,3.454,6.927,6.927,0,0,1-1.8,2.428,7.254,7.254,0,0,1-2.519,1.382,9.381,9.381,0,0,1-2.828.44h-5.038a.24.24,0,0,1-.248-.251V19.332a.253.253,0,0,1,.248-.252h4.894a11.03,11.03,0,0,1,2.87.377,6.933,6.933,0,0,1,2.581,1.256,6.632,6.632,0,0,1,1.837,2.366,8.666,8.666,0,0,1,.681,3.643m-9.25,4.1h1.115a6.021,6.021,0,0,0,1.631-.23,3.4,3.4,0,0,0,1.342-.67,3.291,3.291,0,0,0,.929-1.235,5.756,5.756,0,0,0,0-3.957,3.063,3.063,0,0,0-.929-1.214,3.312,3.312,0,0,0-1.322-.67,6.458,6.458,0,0,0-1.569-.188h-1.2Z",
    transform: "translate(-83.754 -9.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65186",
    "data-name": "Path 65186",
    d: "M200.286,19.331V34.174a.242.242,0,0,1-.251.251h-3.6a.242.242,0,0,1-.251-.251V19.331a.242.242,0,0,1,.251-.251h3.6a.242.242,0,0,1,.251.251",
    transform: "translate(-99.023 -9.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65187",
    "data-name": "Path 65187",
    d: "M222.271,26.7a8.915,8.915,0,0,1-.544,3.14,7.531,7.531,0,0,1-1.549,2.45,7.274,7.274,0,0,1-2.345,1.591,8.121,8.121,0,0,1-2.952.544,7.925,7.925,0,0,1-2.931-.544,7.056,7.056,0,0,1-2.345-1.591,7.531,7.531,0,0,1-1.549-2.45,9.391,9.391,0,0,1,0-6.3,7.563,7.563,0,0,1,1.549-2.408A6.893,6.893,0,0,1,211.95,19.6a8.467,8.467,0,0,1,5.862,0,6.982,6.982,0,0,1,2.366,1.528,7.563,7.563,0,0,1,1.549,2.408,8.948,8.948,0,0,1,.544,3.161m-4.92,2.931a3.961,3.961,0,0,0,.712-1.277,5.264,5.264,0,0,0,.272-1.654,4.908,4.908,0,0,0-.272-1.612,3.608,3.608,0,0,0-.712-1.277,3.135,3.135,0,0,0-2.47-1.109,3.328,3.328,0,0,0-1.382.293,3.284,3.284,0,0,0-1.089.837,3.345,3.345,0,0,0-.712,1.256,4.914,4.914,0,0,0-.251,1.612,4.719,4.719,0,0,0,.272,1.654,3.608,3.608,0,0,0,.712,1.277,3.217,3.217,0,0,0,1.068.837,3.4,3.4,0,0,0,2.764,0,3.529,3.529,0,0,0,1.089-.837",
    transform: "translate(-104.741 -9.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65188",
    "data-name": "Path 65188",
    d: "M248.71,34.417H246.5a1.015,1.015,0,0,1-1.009-1.018V31.675h-5.1a1.038,1.038,0,0,1-1.03-1.018V28.5a.975.975,0,0,1,.171-.541l5.624-9.212a.963.963,0,0,1,.851-.5h2.7a1.015,1.015,0,0,1,1.01,1.018v8.277h.023a1.015,1.015,0,0,1,1.009,1.018v2.094a1.015,1.015,0,0,1-1.009,1.018h-.023V33.4a1.015,1.015,0,0,1-1.01,1.018m-2.7-15.346a.144.144,0,0,0-.135.08l-.01.017L240.224,28.4l-.02.03a.171.171,0,0,0-.023.07v2.156a.211.211,0,0,0,.208.2H245.9a.411.411,0,0,1,.411.411V33.4a.193.193,0,0,0,.188.2h2.209a.193.193,0,0,0,.188-.2V31.264a.411.411,0,0,1,.411-.411h.434a.192.192,0,0,0,.188-.2V28.563a.192.192,0,0,0-.188-.2h-.434a.41.41,0,0,1-.411-.411V19.268a.193.193,0,0,0-.188-.2Zm-.1,9.3h-2.127a.411.411,0,0,1-.355-.618l2.127-3.643a.411.411,0,0,1,.766.207v3.643a.411.411,0,0,1-.411.411m-1.411-.822h1V25.832Z",
    transform: "translate(-120.816 -9.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65189",
    "data-name": "Path 65189",
    d: "M279.407,34.417h-3.654a.631.631,0,0,1-.6-.458l-.9-2.452h-4.354l-.835,2.464c0,.006,0,.012-.007.019a.651.651,0,0,1-.61.427h-3.572a.661.661,0,0,1-.55-.29.389.389,0,0,1-.025-.044.76.76,0,0,1-.051-.531.473.473,0,0,1,.015-.049l5.7-14.822a.651.651,0,0,1,.61-.431h3.2a.644.644,0,0,1,.589.428l5.632,14.788a.645.645,0,0,1,.075.289.654.654,0,0,1-.659.662m-3.458-.658h0m-.054-.163h3.267l-5.531-14.524h-2.94L265.105,33.6h3.214l.891-2.631a.411.411,0,0,1,.389-.279h4.935a.411.411,0,0,1,.385.269Zm-2.434-5.48h-2.746a.411.411,0,0,1-.389-.543l1.383-4.062a.411.411,0,0,1,.389-.278h0a.411.411,0,0,1,.389.28l1.362,4.062a.411.411,0,0,1-.389.541m-2.172-.822h1.6l-.794-2.368Z",
    transform: "translate(-133.364 -9.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65190",
    "data-name": "Path 65190",
    d: "M307.822,34.417h-9.064a.653.653,0,0,1-.659-.662V18.912a.661.661,0,0,1,.659-.662h3.489a.661.661,0,0,1,.659.662V29.974h4.916a.653.653,0,0,1,.658.662v3.119a.653.653,0,0,1-.658.662m-8.9-.822h8.738V30.8h-5.164a.411.411,0,0,1-.411-.411V19.072h-3.163Z",
    transform: "translate(-150.465 -9.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65191",
    "data-name": "Path 65191",
    d: "M330.584,34.417H321.52a.653.653,0,0,1-.659-.662V18.912a.661.661,0,0,1,.659-.662h3.489a.661.661,0,0,1,.659.662V29.974h4.916a.653.653,0,0,1,.658.662v3.119a.653.653,0,0,1-.658.662m-8.9-.822h8.738V30.8h-5.163a.411.411,0,0,1-.411-.411V19.072h-3.163Z",
    transform: "translate(-161.954 -9.212)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardio4AllLogo);
export default __webpack_public_path__ + "static/media/cardio4all-logo.4b120a186af1658d878445eadd8a551b.svg";
export { ForwardRef as ReactComponent };